<template>
    
    <div class="main">
        <c-panel>
            <form-grupo-usuario :paramId="$route.params.id" v-on:onSubmitGrupoUsuario="onSubmitGrupoUsuario"></form-grupo-usuario>
        </c-panel>
    </div>
    
</template>
<script>

import formGrupoUsuario from "./form"

export default {
    methods:{
        onSubmitGrupoUsuario(){
            this.$router.push('/admin/grupo-usuario');  
        }
    },
    components:{ formGrupoUsuario }
}
</script>

